import { TTradingFold } from '../../../../types/partner-page-types';
import { SectionHeader } from '../../utils/section-header';

interface ITradingSection {
  tradingSection: TTradingFold;
}
export const TradingSection: React.FC<ITradingSection> = ({
  tradingSection,
}): JSX.Element => {
  if (!tradingSection.active) return <></>;
  return (
    <div className="w-full bg-grey-190 py-20 sm:py-16">
      <div className="wg-container flex flex-col items-center overflow-x-hidden">
        <div className="w-4/5 text-center md:w-full sm:w-full sm:text-left">
          <SectionHeader
            heading={tradingSection.title}
            description={tradingSection.description}
          />
          <div className="pt-12 gap-7 flex justify-center flex-wrap sm:gap-4">
            {tradingSection.cards.map((card) => {
              return (
                <a
                  className="px-6 py-4 w-[calc(33.33%-28px)] bg-white rounded-lg flex items-center sm:p-4 sm:w-[calc(50%-16px)]"
                  style={{
                    boxShadow: '8px 16px 32px rgba(152, 160, 172, 0.12)',
                  }}
                  key={card.title}
                  {...(card.href ? { href: card.href } : {})}
                  target="_blank"
                >
                  <img
                    className="w-12 h-12 sm:w-7 sm:h-7"
                    src={card.icon}
                    alt={'icon'}
                  ></img>
                  <p className="text-s-24 pl-4 font-bold text-font-500 sm:text-base sm:pl-2.5">
                    {card.title}
                  </p>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
